/**
 * Actions related to chat theme management
 */

// Action types
export const SET_CHAT_THEME = 'SET_CHAT_THEME';
export const GET_CHAT_THEME = 'GET_CHAT_THEME';

/**
 * Set the current chat background theme
 * @param {string} theme - The theme ID to set
 * @returns {object} - The action object
 */
export const setChatTheme = (theme) => {
  // Save to local storage for persistence
  localStorage.setItem('burrowChatTheme', theme);
  
  return {
    type: SET_CHAT_THEME,
    payload: theme
  };
};

/**
 * Get the currently saved chat theme from local storage or use default
 * @returns {object} - The action object
 */
export const getChatTheme = () => {
  const savedTheme = localStorage.getItem('burrowChatTheme') || 'BurrowBackLight1';
  
  return {
    type: GET_CHAT_THEME,
    payload: savedTheme
  };
};
